<template>
  <div class="page-container">
    <el-row :gutter="16" v-loading="loading">
      <el-col
        v-for="group in configGroups"
        :key="group.group"
        :xs="24" :sm="24" :md="12" :lg="12"
        style="margin-bottom:16px"
      >
        <el-card shadow="never">
          <div slot="header" class="card-header">
            <span class="group-title">{{ group.label }}</span>
            <el-button
              v-permission="['system:config:update']"
              type="primary"
              size="mini"
              :loading="savingGroup === group.group"
              @click="handleSave(group)"
            >保存</el-button>
          </div>

          <el-form
            v-if="formData[group.group]"
            :ref="`form_${group.group}`"
            :model="formData[group.group]"
            label-width="130px"
            size="small"
          >
            <el-form-item
              v-for="item in group.items"
              :key="item.key"
              :label="item.label"
            >
              <el-input
                v-if="item.type === 'textarea'"
                v-model="formData[group.group][item.key]"
                type="textarea"
                :rows="3"
                :placeholder="item.remark || '请输入'"
              />
              <el-input-number
                v-else-if="item.type === 'number'"
                v-model.number="formData[group.group][item.key]"
                :min="0"
                style="width:160px"
              />
              <el-switch
                v-else-if="item.type === 'boolean'"
                v-model="formData[group.group][item.key]"
                active-value="1"
                inactive-value="0"
              />
              <el-input
                v-else
                v-model="formData[group.group][item.key]"
                :placeholder="item.remark || '请输入'"
                clearable
              />
              <div v-if="item.remark" class="config-remark">{{ item.remark }}</div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getConfigList, updateConfig } from '@/api/system-config'

export default {
  name: 'SystemConfig',
  data() {
    return {
      loading: false,
      savingGroup: '',
      configGroups: [],
      formData: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getConfigList()
        this.configGroups = Array.isArray(res.data) ? res.data : []
        this.initFormData()
      } catch (e) {
        this.configGroups = []
        this.$message.error('加载配置失败，请刷新重试')
      } finally {
        this.loading = false
      }
    },
    initFormData() {
      const data = {}
      this.configGroups.forEach(group => {
        data[group.group] = {}
        group.items.forEach(item => {
          data[group.group][item.key] = item.value ?? ''
        })
      })
      this.formData = data
    },
    async handleSave(group) {
      const updates = group.items.map(item => ({
        key: item.key,
        value: String(this.formData[group.group][item.key] ?? '')
      }))
      this.savingGroup = group.group
      try {
        await updateConfig(updates)
        this.$message.success('保存成功')
      } finally {
        this.savingGroup = ''
      }
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; }
.card-header { display: flex; justify-content: space-between; align-items: center; }
.group-title { font-weight: 600; font-size: 14px; }
.config-remark { font-size: 12px; color: #909399; line-height: 1.4; margin-top: 4px; }
</style>
